/* Lo puro del sector "Choferes autorizados", testeable sin el cliente de
 * Supabase. */

/* El celular como lo espera el bot: 549 + característica + abonado. Satelital
 * pega lo que tiene y esto lo lleva a esa forma (saca el 0 de larga distancia y
 * el +54). Es MEJOR ESFUERZO: si queda raro se ve en la lista y se corrige a
 * mano — no adivina la característica de un «15» local suelto. */
export function normalizarNumero(v) {
  let d = String(v ?? "").replace(/\D/g, "").replace(/^0+/, "");
  if (!d) return "";
  if (d.startsWith("549")) return d;
  if (d.startsWith("54")) return "549" + d.slice(2);
  return "549" + d;
}
